// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20oIQ","content":"styles_content__BcvJA"};